import React from 'react';
import { Modal, Descriptions, Tag, Space, Tooltip, Badge } from 'antd';
import { StyledCard } from './styled';
import { createTempDashboard } from '@store/tempDashboard/actions';
import { DASHBOARD_TYPE } from '@utils/constants';
import { InfoCircleOutlined } from '@ant-design/icons';
const { confirm } = Modal;

export const AlertDescription = ({ info }) => {
  return (
    <StyledCard
      title={<h4>AI Alert: {info.alertId}</h4>}
      extra={'status' in info ? <Tag color="blue">{info.alertEndedText}</Tag> : ''}
    >
      <Descriptions size="small" layout="vertical" column={2}>
        <Descriptions.Item label="Metric">{info.metricDisplayName}</Descriptions.Item>

        {'peakValue' in info && (
          <Descriptions.Item label="Peak Value">{info.peakValue}</Descriptions.Item>
        )}

        <Descriptions.Item label="Time issue started">{info.issueStartTime}</Descriptions.Item>
        <Descriptions.Item label={info.timeEndedText}>{info.issueEndTime}</Descriptions.Item>
        {'cumulativeImpactedUniques' in info && (
          <>
            <Descriptions.Item
              label={
                <Tooltip title={'Cumulative Impacted Unique Devices'} placement="topLeft">
                  {'CIUD'}
                  <InfoCircleOutlined style={{ fontSize: 12, verticalAlign: 'super' }} />
                </Tooltip>
              }
            >
              <Space>
                <div>Count: {info.cumulativeImpactedUniques}</div>
                <div>Percentage: {info.impactedPercentage}%</div>
              </Space>
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <Tooltip title={'Cumulative Total Unique Devices'}>
                  {'CTUD'}
                  <InfoCircleOutlined style={{ fontSize: 12, verticalAlign: 'super' }} />
                </Tooltip>
              }
            >
              {info.cumulativeTotalUniques}
            </Descriptions.Item>
          </>
        )}
        <Descriptions.Item label="Root Cause" span={2}>
          {info.rootCause}
        </Descriptions.Item>
      </Descriptions>
    </StyledCard>
  );
};

export const createAlertDashboard = (dispatch, alert) => {
  // defaulting alertType to video as CDN partner alerts have alertType as null
  const { alertId, rootCauseParam, aiAlertType } = alert;

  const dashboard = {
    'module:trends': {
      aiAlerts: {
        selectedAlertId: alertId,
        selectedAlertType: aiAlertType ? aiAlertType : 'VIDEO_ALERT',
      },
    },
  };

  dispatch(
    createTempDashboard(DASHBOARD_TYPE.AI_ALERT_DIAGNOSTICS, dashboard, `Alert: ${rootCauseParam}`),
  );
};

export const confirmAlertDrilldown = (dispatch, data) => {
  const { info, aiAlert } = data;

  confirm({
    title: `Drilldown to this alert?`,
    // icon: <ExclamationCircleFilled />,
    content: <AlertDescription info={info} />,
    onOk() {
      createAlertDashboard(dispatch, aiAlert);
    },
    onCancel() {
      // pass
    },
    width: 550,
    bodyStyle: {
      width: 500,
    },
  });
};
